// The SDK types for the VAT helpers. CommonJS twin of src/util/sdkLoader.js:
// the server renders pages by requiring the webpack client bundle, where a
// plain require resolves the SDK's "browser" build, and that build touches
// `window` the moment it loads. In Node, eval('require') skips webpack and
// loads the Node build, the same instance sdkLoader hands out.
const sdk =
  typeof window === 'undefined'
    ? // eslint-disable-next-line no-eval
      eval('require')('sharetribe-flex-sdk')
    : require('sharetribe-flex-sdk');

module.exports = { types: sdk.types };
